import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { vehicleDetailsFormData } from "./vehicleAllFields";
import FormField from "../../../components/common/FormField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  deleteVehicleAction,
  deleteVehicleSuccess,
  getVehicleById,
  setAddVehicleResponse,
  setUpdateVehicleResponse,
} from "../../../store/reducers/vehicleSlice";
import editIcon from "../../../assets/images/actionIcon/edit.png";
import deleteIcon from "../../../assets/trash1.png";
import dayjs from "dayjs";
import DeleteAlert from "../../../components/common/DeleteAlert";

interface VehiclesDetailsProps {
  selectedId: string | any; // Adjust type as needed
  onEditClick?: () => void;
}

const VehiclesDetails: React.FC<VehiclesDetailsProps> = ({
  selectedId,
  onEditClick,
}) => {
  const { singleVehicle } = useSelector((state: any) => state.vehicle);
  const { userProfile } = useSelector((state: any) => state?.user);
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const { vehicles, isAddVehicleResponse, isUpdateVehicleResponse } =
    useSelector((state: any) => state.vehicle);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedId || isAddVehicleResponse || isUpdateVehicleResponse) {
      dispatch(getVehicleById(selectedId));
      dispatch(setAddVehicleResponse(false));
      dispatch(setUpdateVehicleResponse(false));
    }
  }, [dispatch, selectedId, isAddVehicleResponse, isUpdateVehicleResponse]);

  const handleDeleteAlert = () => {
    setDeleteModelShow(true);
  };

  const handleDelete = () => {
    dispatch(deleteVehicleAction(selectedId));
  };

  useEffect(() => {
    if (isAddVehicleResponse || isUpdateVehicleResponse) {
      setDeleteModelShow(false);
      dispatch(deleteVehicleSuccess(false));
    }
  }, [isAddVehicleResponse, isUpdateVehicleResponse, dispatch]);

  return (
    <>
      {deleteModelShow && (
        <DeleteAlert
          alertModalShow={deleteModelShow}
          onConfirm={() => {
            handleDelete();
          }}
          message={"Are you sure you want to delete this vehicle record?"}
          setAlertModelShow={setDeleteModelShow}
        />
      )}
      <Grid
        container
        sx={{
          width: "100% !important",
          marginTop: "10px",
          padding: "10px !important",
          border: "1px solid #C4CDD5",
          borderRadius: "5px",
          overflow: "hidden",
          background: "#E5F4F1",
          position: "relative",
        }}
      >
        <Box>
          <img
            onClick={handleDeleteAlert}
            src={deleteIcon}
            style={{
              width: "22px",
              height: "22px",
              position: "absolute",
              right: "45px",
              cursor: "pointer",
            }}
            alt="delete"
          />
          <img
            src={editIcon}
            onClick={onEditClick}
            style={{
              width: "20px",
              height: "20px",
              position: "absolute",
              right: "10px",
              cursor: "pointer",
            }}
            alt="edit"
          />
        </Box>

        {vehicleDetailsFormData.map((field, index) => (
          <FormField
            key={`${field.id}-${index}`}
            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
              e.preventDefault()
            }
            {...{
              ...field,
              value: singleVehicle
                ? field.id === "service_due" || field.id === "mot_due"
                  ? dayjs(singleVehicle[field.id]).isValid()
                    ? dayjs(singleVehicle[field.id]).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY",
                      )
                    : ""
                  : singleVehicle[field.id]
                : "",
              // Conditional options for county based on country
              disabled: true,

              variant: "outlined", // Adding this variant prop
              isNonMarginTop: true,
              InputProps: {
                sx:
                  field.type === "text" || field.type === "password"
                    ? { height: "36px" }
                    : {
                        padding: "6px 12px",
                        // height: "36px",
                      },
              },
            }}
          />
        ))}
      </Grid>
    </>
  );
};

export default VehiclesDetails;
